import { useCallback, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { selectIsNoDelay } from '../settings/settingsSlice.js'

import Reader from '../../reader/Reader.js'
import { FirebaseMessagingTokenContext, requestDelayedNotification } from '../../firebase'
import { getSecondsUntilTimeOfDay } from '../../alarm/index.js'

export default function StoryScene ({ slice, storyIcon }) {
  const { actions, skipToNextScene, selectors } = slice
  const dispatch = useDispatch()
  const scene = useSelector(selectors.selectScene)
  const sceneArt = useSelector(selectors.selectSceneArt)
  const isShowScene = useSelector(selectors.selectIsShowScene)
  const token = useContext(FirebaseMessagingTokenContext)
  const isNoDelay = useSelector(selectIsNoDelay)
  const doesSkipStraightToNextScene = useSelector(selectors.selectDoesSceneGoStraightToNextScene)
  const nextTimeOfDay = useSelector(selectors.selectNextTimeOfDay)
  const notification = useSelector(selectors.selectNotification)

  const onClose = useCallback(() => {
    if (doesSkipStraightToNextScene) {
      dispatch(skipToNextScene())
    } else {
      const timeOfDay = (!isNoDelay && nextTimeOfDay) ? nextTimeOfDay : null
      if (timeOfDay) {
        requestDelayedNotification({ token, delaySeconds: getSecondsUntilTimeOfDay(timeOfDay), notification })
      }
      dispatch(actions.endScene(timeOfDay))
    }
  }, [dispatch, actions, skipToNextScene, token, isNoDelay, doesSkipStraightToNextScene, nextTimeOfDay, notification])

  return (
    <Reader scene={scene} sceneArt={sceneArt} storyIcon={storyIcon} isOpen={isShowScene} onClose={onClose} />
  )
}
